import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { IonicModule, ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { AppointmentDto } from "src/app/calendar/interfaces/appointment_dto";
import { updateLesson } from "src/app/calendar/ngrx/calendar.actions";
import { selectMileageOfLastLesson } from "src/app/calendar/ngrx/calendar.selectors";
import { ModeService } from "src/app/utils/mode.service";
import { take } from "rxjs";

@Component({
    selector: "app-mileage-dialog",
    templateUrl: "./mileage-dialog.component.html",
    styleUrls: ["./mileage-dialog.component.scss"],
    imports: [IonicModule, FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MileageDialogComponent implements OnInit {
  readonly lesson = input<AppointmentDto>(undefined);

  public mileageForm: FormGroup;
  constructor(
    public modeService: ModeService,
    private modalController: ModalController,
    private store: Store<any>
  ) {
    this.mileageForm = new FormGroup({
      start_mileage: new FormControl(null),
      end_mileage: new FormControl(null),
    });
  }

  ngOnInit() {
    const lesson = this.lesson();
    if (lesson.StartMileage === null && lesson.EndMileage === null) {
      this.store
        .select(selectMileageOfLastLesson)
        .pipe(take(1))
        .subscribe((mileage) => {
          if (mileage) {
            this.mileageForm.patchValue({
              start_mileage: mileage,
            });
          }
        });
    } else {
      this.mileageForm.patchValue({
        start_mileage: lesson.StartMileage,
        end_mileage: lesson.EndMileage,
      });
    }
  }

  cancel() {
    if (this.modalController.getTop() !== undefined) {
      this.modalController.dismiss(null, "cancel");
    }
  }

  save() {
    const lesson = this.mileageForm.value;
    lesson.appointment_id = this.lesson().Id;
    this.store.dispatch(updateLesson({ lesson }));

    if (this.modalController.getTop() !== undefined) {
      this.modalController.dismiss();
    }
  }
}
